import { AxiosError } from "axios";

import { useLogout } from "@/hooks/useLogout";

export const stepHeadingClassName =
  "text-body-base font-semibold leading-none tracking-[0.32px] text-foreground-primary";
export const stepSubheadingClassName =
  "text-body-sm font-semibold leading-none tracking-[0.28px] text-foreground-secondary";
export const stepDescriptionClassName =
  "text-body-sm leading-none tracking-[0.28px] text-foreground-secondary";

export const useLogoutOnTwoFactorError = () => {
  const logout = useLogout();

  return (error: AxiosError) => {
    if (
      error.response?.status === 401 ||
      error.response?.status === 403 ||
      !error.response
    ) {
      logout();
    }
  };
};

export const downloadCodes = (backupCodes: number[]) => {
  const blob = new Blob([backupCodes.join("\n")], {
    type: "text/plain;charset=utf-8",
  });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = "backup-codes.txt";
  a.click();
  URL.revokeObjectURL(url);
};

export const copyCodesToClipboard = (backupCodes: number[]) =>
  navigator.clipboard.writeText(backupCodes.join("\n"));
